import EditInactivityAlertModal from './containers/EditInactivityAlertModalContainer'

export default EditInactivityAlertModal
